var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from "react-router";
import { Button } from "semantic-ui-react";
import { AsyncButton } from "@iscr/views/UIelems/AsyncButton";
import FieldUserFlag from "@iscr/views/UIelems/fields/UserFlag";
import user_model from "models/user_model";
import API_service from "@iscr/xAppLib/providers/API_service";
import { useAsyncUpdate } from "@iscr/xAppLib/Hooks/useAsync";
export function DefaultActionsColumn({ row, refresh, archive_user }) {
    var _a, _b, _c;
    const impersonate = useAsyncUpdate(() => __awaiter(this, void 0, void 0, function* () {
        if (!confirm(`Impersonate ${row.first_name} ${row.last_name}. Are you sure?`))
            return;
        const res = yield API_service.load_data("userAdmin/impers", { uid: row.uid });
        app.state.goback_token = res.goback_token;
        yield user_model.signInWithCustomToken(res.token);
        setTimeout(() => app.history.push("/"), 1000);
    }));
    return (_jsxs(_Fragment, { children: [_jsx(Button, { size: "small", content: "Edit User", compact: true, as: Link, to: `/admin/users/${row.uid}/edit`, state: { user: row } }), !app.acl.is_doc_admin && (_jsx(Button, { content: "Archive", icon: "warning sign", color: "yellow", size: "small", compact: true, onClick: () => archive_user(row) })), (app.user.claims.admin || app.user.claims.supp) && _jsx(FieldUserFlag, { row: row, onUpdate: refresh }), ((_b = (_a = app.user) === null || _a === void 0 ? void 0 : _a.claims) === null || _b === void 0 ? void 0 : _b.root) && !((_c = row.prof) === null || _c === void 0 ? void 0 : _c.par) && (_jsx(AsyncButton, { size: "mini", color: "red", icon: "user secret", compact: true, onClick: impersonate.fn }))] }));
}
